import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('act_bale_qty_logs')
export class ActualBaleQtyLogs {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    

    @Column('int',{
        name:'bale_id',
        nullable:false
    })
    baleId : number

    @Column('decimal',{
        name:'old_quantity',
        precision:10,scale:3,
        nullable:false
    })
    oldQuantity : number

    @Column('decimal',{
        name:'new_quantity',
        precision:10,scale:3,
        nullable:false
    })
    newQuantity : number

    @Column('date',{
        name:'date',
        nullable:false
    })
    date : Date

}